<script lang="ts">
  import type { EventHoursOccurrence } from "../../types";
  import { getNow, getTimeZone } from "../../data/clock";
  import { onDay, isOpenNow } from "../../domain/hours";
  import { placePath } from "../../support/links";
  import { getNextOpening } from "../../domain/events";
  import Timestamp from "../timestamp.svelte";

  export let schedule: Array<EventHoursOccurrence> = [];
  export let time = getNow();
  export let timeZone = getTimeZone();

  $: open = schedule.find((hours) => isOpenNow(hours, $time));
  $: isShowing = onDay(schedule, $time, $timeZone).length > 0;
  $: nextOpening = getNextOpening(schedule, $time, $timeZone);
</script>

<span class="Container">
  {#if open}
    <span class="Label color-status-green">Now</span>

    {#if open.place}
      at
      <a href={placePath(open.place)}>{open.place.title}</a>
    {/if}

    <span>
      until
      <Timestamp time={open.until} {timeZone} />
    </span>
  {:else if nextOpening}
    <span class="Label">
      <Timestamp time={nextOpening.from} {timeZone} />
    </span>
    {#if nextOpening.place}
      at
      <a href={placePath(nextOpening.place)} on:click|stopPropagation>
        {nextOpening.place.title}
      </a>
    {/if}
  {:else}
    <span class="Label color-status-red">
      {#if isShowing}
        Done for day
      {:else}
        No showings
      {/if}
    </span>
  {/if}
</span>

<style>
  .Container {
    line-height: 24px;
  }

  .Label {
    font-weight: 500;
  }
</style>
